import axios from 'axios'
import config from '../config'

const API_URL = config.mySpaceApiUrl
const API_URL_AI = config.aiApiUrl

// CommonData 관련 엔드포인트
export const commonDataEndpoints = {
  checkDuplicate: () => `${API_URL}/common/check-duplicate`,
  getEmploymentStatus: () => `${API_URL}/common/employment-status`,
  getIndustries: () => `${API_URL}/common/industries`,
  getCountries: () => `${API_URL}/common/countries`,
  getRelationships: () => `${API_URL}/common/relations`,
  searchCompany: () => `${API_URL}/common/companies/search`,
  searchFund: () => `${API_URL}/common/funds/search`,
  getCapitalRaisingTypes: () => `${API_URL}/common/capital-raising-types`,
  getStockTypes: () => `${API_URL}/common/stock-types`,
  getStockChangeTypes: () => `${API_URL}/common/stock-change-types`,
  getStockChangeSubTypes: () => `${API_URL}/common/stock-change-sub-types`,
  getRounds: () => `${API_URL}/common/rounds`,
  getCurrency: () => `${API_URL}/common/currencies`,
  getFundCapitalTypes: () => `${API_URL}/common/fund-capital-types`,
  getContributorTypes: () => `${API_URL}/common/contributor-types`,
  getIndustryCodes: () => `${API_URL}/common/industry-codes`,
  getInvestorSectors: () => `${API_URL}/common/investor-sectors`,
}

export const authEndpoints = {
  login: () => `${API_URL}/auth/login`,
  loginWithUserDi: () => `${API_URL}/auth/login/di`,
  mcpCallback: () => `${API_URL}/auth/mcp/callback`,
  authRegister: () => `${API_URL}/auth/register`,
  logout: () => `${API_URL}/auth/logout`,
  checkLogin: () => `${API_URL}/auth/check`,
  checkDuplicate: () => `${API_URL}/auth/check-duplicate`,
  checkEmailDuplicate: () => `${API_URL}/auth/check-email-duplicate`,
  changePassword: () => `${API_URL}/auth/change-password`,

  inisisRequest: () => `${API_URL}/auth/inisis-request`,
  checkDuplicateByDi: () => `${API_URL}/auth/check-duplicate-by-di`,

  verifyEmail: (token: string) => `${API_URL}/auth/verify-email/${token}`,
  resendVerifyEmail: () => `${API_URL}/auth/resend-email-verification`,

}

export const companyEndpoints = {
  checkExistCompany: () => `${API_URL}/company/business-number`,
  registerUserAndCompany: () => `${API_URL}/company/register`,
  registerCompany: () => `${API_URL}/company`,
  matchCompany: () => `${API_URL}/company/match`,
  applyCompany: () => `${API_URL}/company/apply`,
  getApplyCompanyUsers: (companyId: number) => `${API_URL}/company/apply/${companyId}`,
  searchCompany: (keyword: string) => `${API_URL}/company/search/${keyword}`,
  getMasterCompanies: () => `${API_URL}/company/master`,
}

export const inviteEndpoints = {
  getInviteInfoForCompanyUser: (notificationId: string) =>
    `${API_URL}/invite/company-user/${notificationId}`,
  acceptInveteForRegister: () => `${API_URL}/invite/accept-register`,
  acceptInviteForLogin: (notificationId: string) =>
    `${API_URL}/invite/accept/${notificationId}`,
  rejectInvite: (notificationId: string) =>
    `${API_URL}/invite/reject/${notificationId}`
}

export const requestEndpoints = {
  getCompanyInfo: () => `${API_URL}/request-form/company-info`,

  requestCompany: (notificationId: string) =>
    `${API_URL}/request-form/${notificationId}`,

  acceptRequestCompanyForRegistUser: () =>
    `${API_URL}/request-form/submit-register`,
  acceptRequestCompanyForRegistCompany: () => `${API_URL}/request-form/submit`, //회사 만드는거
  acceptRequestCompanyForLogin: () => `${API_URL}/request-form/submit-company`,

  saveDraftRegister: () => `${API_URL}/request-form/save-draft-register`,
  saveDraft: () => `${API_URL}/request-form/save-draft`, //회사 만드는거
  saveDraftCompany: () => `${API_URL}/request-form/save-draft-company`,

  uploadFileTemp: () => `${API_URL}/file/temp`,
  getCompanyRequestForm: (companyId: number, notificationId: string) =>
    `${API_URL}/request-form/company/${companyId}/${notificationId}`
}

export const fileEndpoints = {
  getFile: (id: number) => `${API_URL}/file/${id}/get-signed-url`,
  uploadFile: () => `${API_URL}/file`,
  uploadFileImage: () => `${API_URL}/file/images`,
  deleteFile: () => `${API_URL}/file`,
  irFileUpload: (companyId: number) =>
    `${API_URL}/file/${companyId}/portfolio-ir`,

}

// User 관련 엔드포인트
export const userEndpoints = {
  getUserProfile: () => `${API_URL}/user/profile`,
  getRepresentativeCompany: (type: 'portfolioInfo' | 'coldcall' | 'innovate') =>
    `${API_URL}/user/profile-representative/${type}`,
  getAccountSettings: () => `${API_URL}/user/account-settings`,
  getMessagePreference: () => `${API_URL}/user/message-preference`,
  updateMessagePreference: () => `${API_URL}/user/message-preference`,
  updateEmail: () => `${API_URL}/user/email`,
  deleteProfileImage: () => `${API_URL}/user/profile-image`,
  updateProfileImage: () => `${API_URL}/user/profile-image`,
  // 비밀번호 변경 관련 엔드포인트
  getChangePasswordStatus: (token: string) => `${API_URL}/user/change-password/status?token=${token}`,
  getChangePasswordInfo: (token: string) => `${API_URL}/user/change-password?token=${token}`,
  changePassword: () => `${API_URL}/user/change-password`,
}

export const spaceEndpoints = {
  applySpace: () => `${API_URL}/space/apply`,
}

export const companyUserEndpoints = {
  checkDuplicateEmail: () => `${API_URL}/company-user/check-duplicate-email`,
  getCompanyUserList: (companyId: number) => `${API_URL}/company-user/${companyId}`,
  setMaster: (companyUserId: number) => `${API_URL}/company-user/set-master/${companyUserId}`,
  removeMaster: (companyUserId: number) => `${API_URL}/company-user/remove-master/${companyUserId}`,
}

export const notificationEndpoints = {
  getNotifications: (
    page: number,
    limit: number,
    type?: 'TASK' | 'NOTIFICATION',
    serviceId?: number
  ) => {
    let endpoint = `${API_URL}/notification?page=${page}&limit=${limit}`
    if (type) {
      endpoint += `&type=${type}`
    }
    if (serviceId) {
      endpoint += `&serviceId=${serviceId}`
    }
    return endpoint
  },
  getApplyCompanyUser: (notificationId: string) => `${API_URL}/notification/${notificationId}/apply-company-user`,
  acceptApplyCompanyUser: (notificationId: string) => `${API_URL}/notification/${notificationId}/apply-company-user/accept`,
  rejectApplyCompanyUser: (notificationId: string) => `${API_URL}/notification/${notificationId}/apply-company-user/reject`,
}

export const onboardingEndpoints = {
  getOnboardingInfo: (notificationId: string) =>
    `${API_URL}/onboarding/${notificationId}`
}

export const aiEndpoints = {
  checkIsBusy: (companyId: number) => `${API_URL_AI}/ai-request/status/is-busy/${companyId}`,
  isBusy: () => `${API_URL_AI}/ai-request/status/is-busy`,
  aiAnalysisDocuments: () => `${API_URL_AI}/ai-request/analyze/onboarding-documents`,
  aiAnalysisFinancialDocuments: () => `${API_URL_AI}/ai-request/analyze/company-financial`,
  analyzeShareholderList: () => `${API_URL_AI}/ai-request/analyze/stockholder-list`,
  getAnalyzeBusinessRegistration: () => `${API_URL_AI}/ai-request/analyze/business-registration`,
  
  // 새로운 investor 서버 API 엔드포인트
  getCompanyFinancialAiResponse: () => `${API_URL}/company-financial/ai-response`,
}

// CompanyChannel 관련 엔드포인트
export const companyChannelEndpoints = {
  getChannelById: (id: number) => `${API_URL}/company-channel/${id}`,
  getChannelByCode: (code: string) => `${API_URL}/company-channel/code/${code}`
}

// Billing 관련 엔드포인트
export const billingEndpoints = {
  getPlans: (serviceType: string, productType: string) =>
    `${API_URL}/billing/products/${serviceType}/${productType}`,
  getCustomerKey: (companyId: number) =>
    `${API_URL}/billing/${companyId}/customer-key`,
  registerBillingKey: () =>
    `${API_URL}/billing/billing-key`,
  deleteBillingKey: (companyId: number) =>
    `${API_URL}/billing/${companyId}/billing-key`,
  getBillingStatus: (companyId: number) =>
    `${API_URL}/billing/${companyId}/billing-status`,
  getEntitlement: (companyId: number) =>
    `${API_URL}/billing/${companyId}/entitlement`,
  createSubscription: () =>
    `${API_URL}/billing/subscriptions`,
  createFreeSubscription: () =>
    `${API_URL}/billing/subscriptions/free`,
  cancelSubscription: (companyId: number, subscriptionId: number) =>
    `${API_URL}/billing/${companyId}/subscriptions/${subscriptionId}/cancel`,
  revertCancelSubscription: (companyId: number, subscriptionId: number) =>
    `${API_URL}/billing/${companyId}/subscriptions/${subscriptionId}/cancel/revert`,
  getPayments: (companyId: number) =>
    `${API_URL}/billing/${companyId}/payments`,
  getInvoice: (invoiceId: number) =>
    `${API_URL}/billing/invoice/${invoiceId}`,
  createRefundRequest: (companyId: number) =>
    `${API_URL}/billing/${companyId}/refund-requests`,
  getRefundRequests: (companyId: number) =>
    `${API_URL}/billing/${companyId}/refund-requests`,
  createConsultationInquiry: () =>
    `${API_URL}/billing/consultation-inquiries`,
  getChangeablePlans: (companyId: number, subscriptionId: number) =>
    `${API_URL}/billing/${companyId}/subscriptions/${subscriptionId}/changeable-plans`,
  changePlan: (companyId: number, subscriptionId: number) =>
    `${API_URL}/billing/${companyId}/subscriptions/${subscriptionId}/change-plan`,
}

// Email Whitelist 관련 엔드포인트 (개발용)
export const emailWhitelistEndpoints = {
  getWhitelist: () => `${API_URL}/email-whitelist`,
  addEmail: () => `${API_URL}/email-whitelist`,
  updateEmail: (id: number) => `${API_URL}/email-whitelist/${id}`,
  deleteEmail: (id: number) => `${API_URL}/email-whitelist/${id}`,
}

// API 요청 헤더 설정
export const getHeaders = (token?: string) => ({
  'Content-Type': 'application/json',
  ...(token && { Authorization: `Bearer ${token}` })
})

// API 인스턴스 생성
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  user: userEndpoints,
  getHeaders
}
